import { render, staticRenderFns } from "./AILogicEditor.vue?vue&type=template&id=4d8e5ff8&scoped=true"
import script from "./AILogicEditor.vue?vue&type=script&lang=js"
export * from "./AILogicEditor.vue?vue&type=script&lang=js"
import style0 from "./AILogicEditor.vue?vue&type=style&index=0&id=4d8e5ff8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8e5ff8",
  null
  
)

export default component.exports